import { environment } from '../../../environments/environment';

export { environment as Config };
